module.exports = __webpack_public_path__ + "static/img/earth.931474c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/earth.jpg
// module id = 21
// module chunks = 1